import { withInstall } from '@vuemap/vue-amap-util'
import Amap from './amap.vue'

export const ElAmap = withInstall(Amap)
export default ElAmap
